
import React, {useEffect} from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ReactGA from "react-ga4";
import TagManager from "react-gtm-module";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import ServicesAndLocations from "./pages/Services/ServicesAndLocations";
import LandscapeMaintenance from "./pages/Services/LandscapeMaintenance";
import CommercialLandscapeMaintenance from "./pages/Services/LandscapeMaintenance/CommercialLandscapeMaintenance";
import ResidentialLandscapeMaintenance from "./pages/Services/LandscapeMaintenance/ResidentialLandscapeMaintenance";
import StrataLandscapeMaintenance from "./pages/Services/LandscapeMaintenance/StrataLandscapeMaintenance ";
import ResidentialLawnCare from "./pages/Services/ResidentialLawnCare";
import Liming from "./pages/Services/ResidentialLawnCare/Liming";
import MossControl from "./pages/Services/ResidentialLawnCare/MossControl";
import OrganicWeedControl from "./pages/Services/ResidentialLawnCare/OrganicWeedControl";
import Topdressing from "./pages/Services/ResidentialLawnCare/Topdressing";
import Overseeding from "./pages/Services/ResidentialLawnCare/Overseeding";
import ChaferBeetleControl from "./pages/Services/ChaferBeetleControl";
import LeafCleanup from "./pages/Services/GardenCleanups/LeafCleanup";
import GardenCleanups from "./pages/Services/GardenCleanups";
import PruningShearing from "./pages/Services/GardenCleanups/GardenCleanup/PruningShearing";
import BlackberryRemoval from "./pages/Services/GardenCleanups/GardenCleanup/BlackberryRemoval";
import GardenCleanup from "./pages/Services/GardenCleanups/GardenCleanup";
import HardscapeInstallsMaintenance from "./pages/Services/HardscapeInstallsMaintenance";
import SoftscapeInstallsMaintenance from "./pages/Services/SoftscapeInstallsMaintenance";
import DesignAndModelling from "./pages/Services/DesignAndModelling";
import SnowManagement from "./pages/Services/SnowManagement";
import FertilisationPackage from "./pages/Services/FertilisationPackage";
import LawnPackage from "./pages/Services/LawnPackage";
import PrivacyPolicy from "./pages/Privacy";
import EFleet from './pages/EFleet';
import Projects from "./pages/Projects";
import PavingStone from "./pages/Projects/PavingStone";
import Design3d from "./pages/Projects/Design3d";
import RetainingWall from "./pages/Projects/RetainingWall";
import Plantings from "./pages/Projects/Plantings";
import OneTimeCleanups from "./pages/Projects/OneTimeCleanups";
import TurfInstalls from "./pages/Projects/TurfInstalls";
import ContactUs from "./pages/ContactUs";
import JoinOurTeam from "./pages/JoinOurTeam";
import Blog from "./pages/Blog";
import FertilizerBlog from "./pages/Blog/FertilizerBlog";
import PavingStoneBlog from "./pages/Blog/PavingStoneBlog";
import BeesBlog from "./pages/Blog/BeesBlog";
import ChaferBeetleBlog from "./pages/Blog/ChaferBeetleBlog";
import SeasonalGuideBlog from "./pages/Blog/SeasonalGuideBlog";
import WateringLawnBlog from "./pages/Blog/WateringLawnBlog";
import PollinatorBlog from "./pages/Blog/PollinatorBlog";
import FallLeafCleanupBlog from "./pages/Blog/FallLeafCleanupBlog";
import BlackberryRemovalBlog from "./pages/Blog/BlackberryRemovalBlog";
import CuttingPerennialsBlog from "./pages/Blog/CuttingPerennialsBlog";
import LateFallGardeningBlog from "./pages/Blog/LateFallGardeningBlog";
import SoilAndMulchBlog from "./pages/Blog/SoilAndMulchBlog";
import SnowIceManagementBlog from './pages/Blog/SnowIceManagementBlog';
import ReplacingTimberwallBlog from './pages/Blog/ReplacingTimberwallBlog';
import ExpertWalkwayBlog from './pages/Blog/ExpertWalkwayBlog';
import SpringLawnBlog from './pages/Blog/SpringLawnBlog';
import RedThreadBlog from './pages/Blog/RedThredBlog';
import SustainableLandscapingBlog from "./pages/Blog/SustainableLandscapingBlog";
import CedarTimberBlog from "./pages/Blog/CedarTimberBlog";
import CreatingYourOutdoorBlog from "./pages/Blog/CreatingYourOutdoorBlog";
import AeratingYourLawnBlog from "./pages/Blog/AeratingYourLawnBlog";
import FertilizerLabelBlog from "./pages/Blog/FertilizerLabelBlog";
import SpringGardenBlog from "./pages/Blog/SpringGardenBlog";
import AllElectricBlog from "./pages/Blog/AllElectricBlog";
import MasteringTheArtBlog from "./pages/Blog/MasteringTheArtBlog";
import TheUltimateGuidetoWatering from "./pages/Blog/The Ultimate Guide to Watering ";
import ElectrificationOfLandscaping from "./pages/Blog/ElectrificationOfLandscaping";
import ProfessionalLawnCutting from "./pages/Blog/ProfessionalLawnCutting";
import SunkenConcreteWalkwayOptions from "./pages/Blog/SunkenConcreteWalkwayOptions";
import WalkwayInstallation from "./pages/Blog/WalkwayInstallation";
import WeeklyLawnCutting from "./pages/Blog/WeeklyLawnCutting";
import LawnIsAliveBlog from "./pages/Blog/LawnIsAlive";
import FlourishingFlowerGardenBlog from './pages/Blog/FlourishingFlowerGardenBlog'
import VancouverLawnWateringBlog from './pages/Blog/VancouverLawnWateringBlog'
import DykhofBlog from './pages/Blog/DykhofBlog'
import EcoFriendlyLawnCareBlog from "./pages/Blog/EcoFriendlyLawnCareBlog";
import LawnForWinterBlog from "./pages/Blog/LawnForWinterBlog";
import WhenToFertilizeLawnBlog from "./pages/Blog/WhenToFertilizeLawnBlog";
import MossControlBlog from "./pages/Blog/MossControlBlog";
import SpringLawnCareChecklistBlog from "./pages/Blog/SpringLawnCareChecklistBlog";
import HowOftenMowBlog from "./pages/Blog/HowOftenMowBlog";
import FixChaferBeetleDamageBlog from "./pages/Blog/FixChaferBeetleDamageBlog";
import OrganicVsSyntheticFertilizerBlog from "./pages/Blog/OrganicVsSyntheticFertilizerBlog";

import Vancouver from "./pages/ServiceArea/Vancouver";
import NorthVancouver from "./pages/ServiceArea/NorthVancouver";
import WestVancouver from "./pages/ServiceArea/WestVancouver";
import Burnaby from "./pages/ServiceArea/Burnaby";
import Richmond from "./pages/ServiceArea/Richmond";
import PittMeadows from "./pages/ServiceArea/PittMeadows";
import NewWestminster from "./pages/ServiceArea/NewWestminster";
import Coquitlam from "./pages/ServiceArea/Coquitlam";
import PortCoquitlam from "./pages/ServiceArea/PortCoquitlam";
import PortMoody from "./pages/ServiceArea/PortMoody";
import MapleRidge from "./pages/ServiceArea/MapleRidge";
import Delta from "./pages/ServiceArea/Delta";
import Surrey from "./pages/ServiceArea/Surrey";
import WhiteRock from "./pages/ServiceArea/WhiteRock";
import Langley from "./pages/ServiceArea/Langley";


import WestVancouverLawnMowing from "./pages/LandingPages/WestVancouver/WestVancouverLawnMowing";
import NorthVancouverLawnMowing from "./pages/LandingPages/NorthVancouver/NorthVancouverLawnMowing";
import VancouverLawnMowing from "./pages/LandingPages/Vancouver/VancouverLawnMowing";
import BurnabyLawnMowing from "./pages/LandingPages/Burnaby/BurnabyLawnMowing"
import RichmondLawnMowing from "./pages/LandingPages/Richmond/RichmondLawnMowing";
import PittMeadowsLawnMowing from "./pages/LandingPages/PittMeadows/PittMeadowsLawnMowing";
import NewWestminsterLawnMowing from "./pages/LandingPages/NewWestminster/NewWestminsterLawnMowing";
import CoquitlamLawnMowing from "./pages/LandingPages/Coquitlam/CoquitlamLawnMowing";
import PortCoquitlamLawnMowing from "./pages/LandingPages/PortCoquitlam/PortCoquitlamLawnMowing";
import PortMoodyLawnMowing from "./pages/LandingPages/PortMoody/PortMoodyLawnMowing";
import MapleRidgeLawnMowing from "./pages/LandingPages/MapleRidge/MapleRidgeLawnMowing";
import DeltaLawnMowing from "./pages/LandingPages/Delta/DeltaLawnMowing";
import SurreyLawnMowing from "./pages/LandingPages/Surrey/SurreyLawnMowing";
import WhiteRockLawnMowing from "./pages/LandingPages/WhiteRock/WhiteRockLawnMowing";
import LangleyLawnMowing from "./pages/LandingPages/Langley/LangleyLawnMowing";

import WestVancouverLawnAeration from "./pages/LandingPages/WestVancouver/WestVancouverLawnAeration";
import NorthVancouverLawnAeration from "./pages/LandingPages/NorthVancouver/NorthVancouverLawnAeration";
import VancouverLawnAeration from "./pages/LandingPages/Vancouver/VancouverLawnAeration";
import BurnabyLawnAeration from "./pages/LandingPages/Burnaby/BurnabyLawnAeration";
import RichmondLawnAeration from "./pages/LandingPages/Richmond/RichmondLawnAeration";
import PittMeadowsLawnAeration from "./pages/LandingPages/PittMeadows/PittMeadowsLawnAeration";
import NewWestminsterLawnAeration from "./pages/LandingPages/NewWestminster/NewWestminsterLawnAeration";
import CoquitlamLawnAeration from "./pages/LandingPages/Coquitlam/CoquitlamLawnAeration";
import PortCoquitlamLawnAeration from "./pages/LandingPages/PortCoquitlam/PortCoquitlamLawnAeration ";
import PortMoodyLawnAeration from "./pages/LandingPages/PortMoody/PortMoodyLawnAeration";
import MapleRidgeLawnAeration from "./pages/LandingPages/MapleRidge/MapleRidgeLawnAeration";
import DeltaLawnAeration from "./pages/LandingPages/Delta/DeltaLawnAeration";
import SurreyLawnAeration from "./pages/LandingPages/Surrey/SurreyLawnAeration";
import WhiteRockLawnAeration from "./pages/LandingPages/WhiteRock/WhiteRockLawnAeration";
import LangleyLawnAeration from "./pages/LandingPages/Langley/LangleyLawnAeration";

import WestVancouverLawnFertilizing from "./pages/LandingPages/WestVancouver/WestVancouverLawnFertilizing";
import NorthVancouverLawnFertilizing from "./pages/LandingPages/NorthVancouver/NorthVancouverLawnFertilizing";
import VancouverLawnFertilizing from "./pages/LandingPages/Vancouver/VancouverLawnFertilizing";
import BurnabyLawnFertilizing from "./pages/LandingPages/Burnaby/BurnabyLawnFertilizing";
import RichmondLawnFertilizing from "./pages/LandingPages/Richmond/RichmondLawnFertilizing";
import PittMeadowsLawnFertilizing from "./pages/LandingPages/PittMeadows/PittMeadowsLawnFertilizing";
import NewWestminsterLawnFertilizing from "./pages/LandingPages/NewWestminster/NewWestminsterLawnFertilizing";
import CoquitlamLawnFertilizing from "./pages/LandingPages/Coquitlam/CoquitlamLawnFertilizing";
import PortCoquitlamLawnFertilizing from "./pages/LandingPages/PortCoquitlam/PortCoquitlamLawnFertilizing";
import PortMoodyLawnFertilizing from "./pages/LandingPages/PortMoody/PortMoodyLawnFertilizing";
import MapleRidgeLawnFertilizing from "./pages/LandingPages/MapleRidge/MapleRidgeLawnFertilizing";
import DeltaLawnFertilizing from "./pages/LandingPages/Delta/DeltaLawnFertilizing";
import SurreyLawnFertilizing from "./pages/LandingPages/Surrey/SurreyLawnFertilizing";
import WhiteRockLawnFertilizing from "./pages/LandingPages/WhiteRock/WhiteRockLawnFertilizing";
import LangleyLawnFertilizing from "./pages/LandingPages/Langley/LangleyLawnFertilizing";
import NotFound from "./pages/NotFound";

export default function App() {

  const tagManagerArgs = {
    gtmId: process.env.REACT_APP_TAG_KEY,
  };
  TagManager.initialize(tagManagerArgs);

  const TRACKING_ID = process.env.REACT_APP_TRACKING_ID;
  ReactGA.initialize(TRACKING_ID);

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true,
      mirror: false,
      disable: window.innerWidth < 768,
    });
  }, []);

  return (

    <BrowserRouter>
    {/* <div className="snow-container">
      <div className="snow"></div>
    </div> */}
      <Routes>

        {/* Main Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/our-projects" element={<Projects />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/join-our-team" element={<JoinOurTeam />} />
        <Route path="/blog" element={<Blog />} />
        {/* Services Routes */}
        <Route
          path="/services/services-and-locations"
          element={<ServicesAndLocations />}
        />
        <Route
          path="/services/landscape-maintenance"
          element={<LandscapeMaintenance />}
        />
        <Route
          path="/services/landscape-maintenance/commercial-landscape-maintenance"
          element={<CommercialLandscapeMaintenance />}
        />{" "}
        <Route
          path="/services/landscape-maintenance/residential-landscape-maintenance"
          element={<ResidentialLandscapeMaintenance />}
        />{" "}
        <Route
          path="/services/landscape-maintenance/strata-landscape-maintenance"
          element={<StrataLandscapeMaintenance />}
        />
        <Route
          path="/services/residential-lawn-care"
          element={<ResidentialLawnCare />}
        />
        <Route path="/services/residential-lawn-care/liming" element={<Liming />} />
        <Route path="/services/residential-lawn-care/moss-control" element={<MossControl />} />
        <Route path="/services/residential-lawn-care/organic-weed-control" element={<OrganicWeedControl />} />
        <Route path="/services/residential-lawn-care/topdressing" element={<Topdressing />} />
        <Route path="/services/residential-lawn-care/overseeding" element={<Overseeding />} />
        <Route
          path="/services/hardscape-installs-maintenance"
          element={<HardscapeInstallsMaintenance />}
        />
        <Route
          path="/services/softscape-installs-maintenance"
          element={<SoftscapeInstallsMaintenance />}
        />
        <Route
          path="/services/design-and-modelling"
          element={<DesignAndModelling />}
        />
        <Route path="/services/snow-management" element={<SnowManagement />} />
        <Route
          path="/services/european-chafer-beetle-control"
          element={<ChaferBeetleControl />}
        />
        <Route path="/services/garden-cleanups" element={<GardenCleanups />} />
        <Route
          path="/services/garden-cleanups/leaf-cleanup"
          element={<LeafCleanup />}
        />
        <Route
          path="/services/garden-cleanups/garden-cleanup"
          element={<GardenCleanup />}
        />
        <Route
          path="/services/garden-cleanups/garden-cleanup/pruning-shearing"
          element={<PruningShearing />}
        />
        <Route
          path="/services/garden-cleanups/garden-cleanup/blackberry-removal"
          element={<BlackberryRemoval />}
        />
        {/* <Route
          path="/services/fertilisation-package"
          element={<FertilisationPackage />}
        /> */}
         {/* <Route
          path="/services/lawn-package"
          element={<LawnPackage />}
        /> */}
        <Route path="/e-fleet" element={<EFleet />} />

        {/* Projects Routes */}
        <Route path="/our-projects/3d-design" element={<Design3d />} />
        <Route path="/our-projects/paving-stones" element={<PavingStone />} />
        <Route
          path="/our-projects/retaining-walls"
          element={<RetainingWall />}
        />
        <Route
          path="/our-projects/one-time-cleanups"
          element={<OneTimeCleanups />}
        />
        <Route path="/our-projects/turf-installs" element={<TurfInstalls />} />
        <Route path="/our-projects/plantings" element={<Plantings />} />
        {/* Blog Routes */}
        <Route
          path="/blog/paving-stone-quality-and-value"
          element={<PavingStoneBlog />}
        />
        <Route path="/blog/saving-the-bees" element={<BeesBlog />} />
        <Route path="/blog/chafer-beetle" element={<ChaferBeetleBlog />} />
        <Route
          path="/blog/garden-maintenance-guide"
          element={<SeasonalGuideBlog />}
        />
        <Route
          path="/blog/the-essential-guide-to-lawn-fertilization"
          element={<FertilizerBlog />}
        />
        <Route
          path="/blog/responsible-lawn-watering-in-vancouver"
          element={<WateringLawnBlog />}
        />
        <Route
          path="/blog/creating-a-pollinator-and-native-plant-garden"
          element={<PollinatorBlog />}
        />
        <Route
          path="/blog/the-importance-of-a-fall-leaf-cleanup"
          element={<FallLeafCleanupBlog />}
        />
        <Route
          path="/blog/the-essential-guide-to-blackberry-removal-in-greater-vancouver"
          element={<BlackberryRemovalBlog />}
        />
        <Route
          path="/blog/cutting-back-perennials-in-vancouver-a-gardener's-guide"
          element={<CuttingPerennialsBlog />}
        />
        <Route
          path="/blog/late-fall-gardening-bulbs-to-remove-and-plant-in-november-and-december"
          element={<LateFallGardeningBlog />}
        />
        <Route
          path="/blog/understanding-the-power-of-soils-and-mulch-in-gardening"
          element={<SoilAndMulchBlog />}
        />
         <Route
          path="/blog/snow-and-ice-management-tips-for-north-and-west-vancouver-homeowners"
          element={<SnowIceManagementBlog />}
        />
         <Route
          path="/blog/replacing-a-timber-wall-with-an-allan-block-wall"
          element={<ReplacingTimberwallBlog />}
        />
        <Route
          path="/blog/expert-walkway-installation-in-greater-vancouver-a-complete-guide"
          element={<ExpertWalkwayBlog />}
        />
         <Route
          path="/blog/spring-lawn-and-garden-tips-for-a-healthy-yard"
          element={<SpringLawnBlog />}
        />
        <Route
          path="/blog/red-thread-causes-fixes-and-spring-prevention-tips"
          element={<RedThreadBlog />}
        />
        <Route
        path="/blog/sustainable-landscaping-a-vision-for-north-and-west-vancouver"
        element={<SustainableLandscapingBlog />}
      />
      <Route
        path="/blog/cedar-timber-raised-garden-beds-a-durable-and-safe-choice"
        element={<CedarTimberBlog />}
        />
      <Route
        path="/blog/creating-your-outdoor-living-space-in-vancouver"
        element={<CreatingYourOutdoorBlog />}

      />
      <Route
        path="/blog/aerating-your-lawn-how-to-do-it-right-in-vancouver"
        element={<AeratingYourLawnBlog />}

      />
      <Route
        path="/blog/how-to-read-a-fertilizer-label-and-apply-it-to-your-lawn"
        element={<FertilizerLabelBlog />}
      />
      <Route
        path="/blog/spring-garden-cleanup-guide-for-greater-vancouver"
        element={<SpringGardenBlog />}
      />
      <Route
        path="/blog/bur-han-goes-all-electric!-here's-why-it-matters"
        element={<AllElectricBlog />}
      />
      <Route
        path="/blog/mastering-the-art-of-lawn-mowing-tips-for-a-healthy-vibrant-lawn"
        element={<MasteringTheArtBlog />}
      />
       <Route
        path="/blog/the-ultimate-guide-to-watering-new-turfgrass-sod"
        element={<TheUltimateGuidetoWatering />}
      />
       <Route
        path="/blog/why-electric-lawn-care-benefits-strata-properties-in-vancouver"
        element={<ElectrificationOfLandscaping />}
      />
       <Route
        path="/blog/the-benefits-of-a-professional-lawn-cutting-service-in-vancouver"
        element={<ProfessionalLawnCutting />}
      />
      <Route
        path="/blog/best-repair-options-for-sunken-concrete-walkways"
        element={<SunkenConcreteWalkwayOptions />}
      />
      <Route
        path="/blog/walkway-installation-services-enhance-your-property"
        element={<WalkwayInstallation />}
      />
       <Route
        path="/blog/weekly-lawn-cutting-service-in-vancouver-surrounding-areas"
        element={<WeeklyLawnCutting />}
      />
       <Route
        path="/blog/soil-health-lawn-vancouver-compost-service"
        element={<LawnIsAliveBlog />}
      />
       <Route
        path="/blog/the-secret-to-a-flourishing-flower-garden"
        element={<FlourishingFlowerGardenBlog />}
      />
      <Route
        path="/blog/how-to-keep-your-vancouver-lawn-green"
        element={<VancouverLawnWateringBlog />}
      />
      <Route
        path="/blog/Dykhof-nurseries"
        element={<DykhofBlog />}
      />
      <Route
        path="/blog/eco-friendly-lawn-care"
        element={<EcoFriendlyLawnCareBlog />}
      />
      <Route
        path="/blog/how-to-prepare-your-lawn-for-winter"
        element={<LawnForWinterBlog />}
      />
      <Route
        path="/blog/when-to-fertilize-lawn-vancouver"
        element={<WhenToFertilizeLawnBlog />}
      />
      <Route
        path="/blog/moss-control-vancouver-lawns"
        element={<MossControlBlog />}
      />
      <Route
        path="/blog/spring-lawn-care-checklist-vancouver"
        element={<SpringLawnCareChecklistBlog />}
      />
      <Route
        path="/blog/how-often-mow-lawn-vancouver"
        element={<HowOftenMowBlog />}
      />
      <Route
        path="/blog/how-to-fix-chafer-beetle-lawn-damage"
        element={<FixChaferBeetleDamageBlog />}
      />
      <Route
        path="/blog/organic-vs-synthetic-fertilizer-vancouver"
        element={<OrganicVsSyntheticFertilizerBlog />}
      />

        {/* Service Area Routes */}
        <Route path="/landscaping-vancouver" element={<Vancouver />} />

        <Route path="/landscaping-north-vancouver" element={<NorthVancouver />}/>
        <Route path="/landscaping-west-vancouver" element={<WestVancouver />} />
        <Route path="/landscaping-burnaby" element={<Burnaby />} />
        <Route path="/landscaping-richmond" element={<Richmond />} />
        <Route path="/landscaping-pittmeadows" element={<PittMeadows />} />
        <Route
          path="/landscaping-new-westminster"
          element={<NewWestminster />}
        />
        <Route path="/landscaping-coquitlam" element={<Coquitlam />} />
        <Route
          path="/landscaping-port-coquitlam"
          element={<PortCoquitlam />}
        />
        <Route path="/landscaping-port-moody" element={<PortMoody />} />
        <Route path="/landscaping-maple-ridge" element={<MapleRidge />} />
        <Route path="/landscaping-delta" element={<Delta />} />
        <Route path="/landscaping-surrey" element={<Surrey />} />
        <Route path="/landscaping-white-rock" element={<WhiteRock />} />
        <Route path="/landscaping-pitt-meadows" element={<PittMeadows />} />
        <Route path="landscaping-langley" element={<Langley />} />

        <Route path="/lawn-mowing-west-vancouver" element={<WestVancouverLawnMowing />} />
        <Route path="/lawn-mowing-north-vancouver" element={<NorthVancouverLawnMowing />} />
        <Route path="/lawn-mowing-vancouver" element={<VancouverLawnMowing />} />
        <Route path="/lawn-mowing-burnaby" element={<BurnabyLawnMowing />} />
        <Route path="/lawn-mowing-coquitlam" element={<CoquitlamLawnMowing />} />
        <Route path="/lawn-mowing-port-coquitlam" element={<PortCoquitlamLawnMowing />} />
        <Route path="/lawn-mowing-delta" element={<DeltaLawnMowing />} />
        <Route path="/lawn-mowing-maple-ridge" element={<MapleRidgeLawnMowing />} />
        <Route path="/lawn-mowing-new-westminster" element={<NewWestminsterLawnMowing />} />
        <Route path="/lawn-mowing-pitt-meadows" element={<PittMeadowsLawnMowing />} />
        <Route path="/lawn-mowing-port-moody" element={<PortMoodyLawnMowing />} />
        <Route path="/lawn-mowing-richmond" element={<RichmondLawnMowing />} />
        <Route path="/lawn-mowing-white-rock" element={<WhiteRockLawnMowing />} />
        <Route path="/lawn-mowing-surrey" element={<SurreyLawnMowing />} />
        <Route path="/lawn-mowing-langley" element={<LangleyLawnMowing />} />

        <Route path="/lawn-aeration-west-vancouver" element={<WestVancouverLawnAeration />} />
        <Route path="/lawn-aeration-north-vancouver" element={<NorthVancouverLawnAeration />} />
        <Route path="/lawn-aeration-vancouver" element={<VancouverLawnAeration />} />
        <Route path="/lawn-aeration-burnaby" element={<BurnabyLawnAeration />} />
        <Route path="/lawn-aeration-coquitlam" element={<CoquitlamLawnAeration />} />
        <Route path="/lawn-aeration-port-coquitlam" element={<PortCoquitlamLawnAeration />} />
        <Route path="/lawn-aeration-delta" element={<DeltaLawnAeration />} />
        <Route path="/lawn-aeration-maple-ridge" element={<MapleRidgeLawnAeration />} />
        <Route path="/lawn-aeration-new-westminster" element={<NewWestminsterLawnAeration />} />
        <Route path="/lawn-aeration-pitt-meadows" element={<PittMeadowsLawnAeration />} />
        <Route path="/lawn-aeration-port-moody" element={<PortMoodyLawnAeration />} />
        <Route path="/lawn-aeration-richmond" element={<RichmondLawnAeration />} />
        <Route path="/lawn-aeration-white-rock" element={<WhiteRockLawnAeration />} />
        <Route path="/lawn-aeration-surrey" element={<SurreyLawnAeration />} />
        <Route path="/lawn-aeration-langley" element={<LangleyLawnAeration />} />

        <Route path="/lawn-fertilizing-west-vancouver" element={<WestVancouverLawnFertilizing />} />
        <Route path="/lawn-fertilizing-north-vancouver" element={<NorthVancouverLawnFertilizing />} />
        <Route path="/lawn-fertilizing-vancouver" element={<VancouverLawnFertilizing />} />
        <Route path="/lawn-fertilizing-burnaby" element={<BurnabyLawnFertilizing />} />
        <Route path="/lawn-fertilizing-coquitlam" element={<CoquitlamLawnFertilizing />} />
        <Route path="/lawn-fertilizing-port-coquitlam" element={<PortCoquitlamLawnFertilizing />} />
        <Route path="/lawn-fertilizing-delta" element={<DeltaLawnFertilizing />} />
        <Route path="/lawn-fertilizing-maple-ridge" element={<MapleRidgeLawnFertilizing />} />
        <Route path="/lawn-fertilizing-new-westminster" element={<NewWestminsterLawnFertilizing />} />
        <Route path="/lawn-fertilizing-pitt-meadows" element={<PittMeadowsLawnFertilizing />} />
        <Route path="/lawn-fertilizing-port-moody" element={<PortMoodyLawnFertilizing />} />
        <Route path="/lawn-fertilizing-richmond" element={<RichmondLawnFertilizing />} />
        <Route path="/lawn-fertilizing-white-rock" element={<WhiteRockLawnFertilizing />} />
        <Route path="/lawn-fertilizing-surrey" element={<SurreyLawnFertilizing />} />
        <Route path="/lawn-fertilizing-langley" element={<LangleyLawnFertilizing />} />
        <Route
        path="/privacy-policy"
        element={<PrivacyPolicy />}

      />

        {/* Catch-all route for 404 page */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

